import { ElMessageBox, ElMessage } from "element-plus";
import { QuestionFilled } from "@element-plus/icons-vue";
/**
 * 消息提示
 * @param msg 提示信息
 * @param type 消息类型
 */
const message = (msg: any, type: any) => {
  ElMessage({
    showClose: true,
    message: msg,
    type: type
  });
};
const messageBox = {
  /**
   * 成功提示
   * @param msg 提示信息
   */
  success: (msg: any) => {
    message(msg, "success");
  },
  /**
   * 消息提示
   * @param msg 提示信息
   */
  info: (msg: any) => {
    message(msg, "info");
  },
  /**
   * 错误提示
   * @param msg 提示信息
   */
  error: (msg: any) => {
    message(msg, "error");
  },

  /**
   * 警告提示
   * @param msg 提示信息
   */
  warning: (msg: any) => {
    message(msg, "warning");
  },

  /**
   * alert提示框
   * @param title 标题
   * @param msg 信息
   * @param ok ok函数
   * @param okText ok按钮文字
   */
  alert: ({ title, msg, ok, okText }: any) => {
    if (!title) {
      title = "提示";
    }
    if (!msg) {
      msg = "错误";
    }
    if (!okText) {
      okText = "确定";
    }
    ElMessageBox.alert(msg, title, {
      confirmButtonText: okText
    }).then(ok ? ok : () => {});
  },

  /**
   * confirm 提示框
   * @param title 标题
   * @param msg 信息
   * @param ok ok函数
   * @param okText ok按钮文字
   * @param cancel 取消函数
   * @param cText cancel按钮文字
   * @param cancelButton cancel 取消按钮
   * @param okButton confirm 确定按钮
   */
  confirm: ({
    name,
    ok,
    cancel,
    msg,
    title,
    okText,
    cText,
    cancelHide,
    okHide,
    type = "info",
    dangerouslyUseHTMLString = false
  }: any) => {
    const tsy = name
      ? `${msg ? msg : "是否删除"} 【${name}】`
      : `${msg ? msg : "是否删除"}`;
    const titles =
      type === "success"
        ? "操作成功"
        : type === "warning"
          ? "警告提示"
          : type === "error"
            ? "错误提示"
            : "操作确认";
    ElMessageBox.confirm(tsy, title || titles, {
      confirmButtonText: cText ? cText : "取消",
      confirmButtonClass: "el-button--info",
      cancelButtonText: okText ? okText : "确定",
      cancelButtonClass: "el-button--primary",
      draggable: true,
      distinguishCancelAndClose: true,
      showCancelButton: !okHide,
      showConfirmButton: cancelHide || type === "info",
      type,
      icon: type === "info" ? markRaw(QuestionFilled) : "",
      dangerouslyUseHTMLString
    })
      .then(cancel ? cancel : () => {})
      .catch(action => {
        if (action === "cancel") {
          ok();
        }
        if (action === "close") {
          cancel();
        }
      });
  },
  prompt({
    msg,
    title = "提示",
    confirmText = "确定",
    cancelText = "取消",
    inputPattern,
    inputErrorMessage,
    ok,
    cancel
  }) {
    ElMessageBox.prompt(msg, title, {
      confirmButtonText: confirmText,
      cancelButtonText: cancelText,
      inputPattern,
      inputErrorMessage
    })
      .then(({ value }) => {
        ok(value);
      })
      .catch(() => {
        if (cancel) cancel();
      });
  }
};
export default messageBox;
